import { HTMLControl } from '../controls/html_control.js';
import { window } from '../window.js';

/**
 * A list of cocampers avatars.
 */
class AvatarList extends HTMLControl {
  set(values = []) {
    this.values = values;
    this.#refresh();
  }

  get friends() {
    return this.#friends;
  }

  set friends(v) {
    if (this.#friends) {
      this.#friends.unpipe(this.#receiver);
    }
    this.#friends = v;
    this.#friends.pipe(this.#receiver);
  }

  static selectors = {
    Avatars: '.avatar',
  };

  #refresh() {
    if (!this.values || !this.#friends) {
      return;
    }

    let content = '';
    for (let v of this.values) {
      let friend = this.#friends.find(v);
      let title = `${friend.name} <${friend.email}>`;
      content += `
        <img src='${friend.avatar}'
             class='avatar'
             title='${title}'>
      `;
    }
    this.innerHTML = content;
  }

  #friends;
  #receiver = this.#refresh.bind(this);
}

window.customElements.define('avatar-list', AvatarList);

export { AvatarList };
